export default "__VITE_ASSET__DXVCv8tb__"